 import React, { useEffect, useRef, useState } from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Theme1InfoCard1 from "./Theme1InfoCard1";
import Theme1InfoCard2 from "./Theme1InfoCard2";
import Theme1InfoCard3 from "./Theme1InfoCard3";
import Theme1InfoCard4 from "./Theme1InfoCard4";
import Theme1InfoCard5 from "./Theme1InfoCard5";
import Theme1InfoCard6 from "./Theme1InfoCard6";
import Theme1SectionCard1 from "./Theme1SectionCard1";
const  Theme1CardsIndexPage = ({ setCurrentContentIndex,currentIndex,CurrentObject ,setCurrentObject, setHideReduUnDo, moveItemUp,moveItemDown,deleteItem,duplicateItem,duplicateContentsItem,item ,dynamicId,
    
}) =>{   const dispatch = useDispatch();
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
    const [reloadItems, setReloadItems] = useState(true);

    useEffect(()=>{
        setReloadItems(false); setReloadItems(true)
    },[ currentIndex]
)
    const extractElementType = (str) => {
  const match = str?.match(/^.*?-(.*?)-.*$/);
  return match ? match[1] : null;
};

return(<>

 {
  extractElementType(item?.myKey)=="Theme1InfoCard1"? <>
  
  <Theme1InfoCard1  setCurrentContentIndex={(currentContentIndex)=>{setCurrentContentIndex(currentContentIndex);
      // alert(currentContentIndex)
    }}
        CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={dynamicId} 
             setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem);
              // alert(parseInt(currentItem?.contentNo)+currentItem?.myKey)
            }}
           
          moveItemUp={(item)=>{moveItemUp(item);}} moveItemDown={(item)=>{moveItemDown(item);}} 
      deleteItem={(item)=>{deleteItem(item);}}  duplicateContentsItem={(item)=>{duplicateContentsItem(item)}}  duplicateItem={(item)=>{duplicateItem(item);}} 
       item={item}
           
      />
     
      
      
     </> :""}{
  extractElementType(item?.myKey)=="Theme1InfoCard2"? <>
   
  <Theme1InfoCard2  setCurrentContentIndex={(currentContentIndex)=>{setCurrentContentIndex(currentContentIndex);
      // alert(currentContentIndex)
    }}
        CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={dynamicId} 
             setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem);
              // alert(parseInt(currentItem?.contentNo)+currentItem?.myKey)
            }}
           
          moveItemUp={(item)=>{moveItemUp(item);}} moveItemDown={(item)=>{moveItemDown(item);}} 
      deleteItem={(item)=>{deleteItem(item);}}  duplicateContentsItem={(item)=>{duplicateContentsItem(item)}}  duplicateItem={(item)=>{duplicateItem(item);}} 
      
      item={item}
           
      />
     
      
      
     </> :""}
  {
  extractElementType(item?.myKey)=="Theme1InfoCard3"? <>
   
  <Theme1InfoCard3  setCurrentContentIndex={(currentContentIndex)=>{setCurrentContentIndex(currentContentIndex);
      // alert(currentContentIndex)
    }}
        CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={dynamicId} 
             setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem);
              // alert(parseInt(currentItem?.contentNo)+currentItem?.myKey)
            }}
          moveItemUp={(item)=>{moveItemUp(item);}} moveItemDown={(item)=>{moveItemDown(item);}} 
      deleteItem={(item)=>{deleteItem(item);}}  duplicateContentsItem={(item)=>{duplicateContentsItem(item)}}  duplicateItem={(item)=>{duplicateItem(item);}} 
       item={item}
           
      />
     
      
      
     </> :""}
 {
  extractElementType(item?.myKey)=="Theme1InfoCard4"? <>
   
  <Theme1InfoCard4  setCurrentContentIndex={(currentContentIndex)=>{setCurrentContentIndex(currentContentIndex);
      // alert(currentContentIndex)
    }}
        CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={dynamicId} 
             setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem);
              // alert(parseInt(currentItem?.contentNo)+currentItem?.myKey)
            }}
           
          moveItemUp={(item)=>{moveItemUp(item);}} moveItemDown={(item)=>{moveItemDown(item);}} 
      deleteItem={(item)=>{deleteItem(item);}}  duplicateContentsItem={(item)=>{duplicateContentsItem(item)}}  duplicateItem={(item)=>{duplicateItem(item);}} 
      
      item={item}
           
      />
     
      
      
     </> :""}

      {
  extractElementType(item?.myKey)=="Theme1InfoCard5"? <>
   
  <Theme1InfoCard5  setCurrentContentIndex={(currentContentIndex)=>{setCurrentContentIndex(currentContentIndex);
      // alert(currentContentIndex)
    }}
        CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={dynamicId} 
             setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem);
              // alert(parseInt(currentItem?.contentNo)+currentItem?.myKey)
            }}
          moveItemUp={(item)=>{moveItemUp(item);}} moveItemDown={(item)=>{moveItemDown(item);}} 
      deleteItem={(item)=>{deleteItem(item);}}  duplicateContentsItem={(item)=>{duplicateContentsItem(item)}}  duplicateItem={(item)=>{duplicateItem(item);}} 
      
      item={item}
           
      />
     
      
      
     </> :""}

      {
  extractElementType(item?.myKey)=="Theme1InfoCard6"? <>
   
  <Theme1InfoCard6  setCurrentContentIndex={(currentContentIndex)=>{setCurrentContentIndex(currentContentIndex);
      // alert(currentContentIndex)
    }}
        CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={dynamicId} 
             setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem);
              // alert(parseInt(currentItem?.contentNo)+currentItem?.myKey)
            }}
           
         moveItemUp={(item)=>{moveItemUp(item);}} moveItemDown={(item)=>{moveItemDown(item);}} 
      deleteItem={(item)=>{deleteItem(item);}}  duplicateContentsItem={(item)=>{duplicateContentsItem(item)}}  duplicateItem={(item)=>{duplicateItem(item);}} 
      
      item={item}
           
      />
     
      
      
     </> :""} {
  extractElementType(item?.myKey)=="T1SectionCard1"? <>
   
  <Theme1SectionCard1  setCurrentContentIndex={(currentContentIndex)=>{setCurrentContentIndex(currentContentIndex);
      // alert(currentContentIndex)
    }}
        CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={dynamicId} 
             setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem);
              // alert(parseInt(currentItem?.contentNo)+currentItem?.myKey)
            }}
           
         moveItemUp={(item)=>{moveItemUp(item);}} moveItemDown={(item)=>{moveItemDown(item);}} 
      deleteItem={(item)=>{deleteItem(item);}}  duplicateContentsItem={(item)=>{duplicateContentsItem(item)}}  duplicateItem={(item)=>{duplicateItem(item);}} 
      
      item={item}
           
      />
     
      
      
     </> :""}
     
</>)
}
export default Theme1CardsIndexPage;